import styled from 'styled-components';
import { maxes, media } from '../../helper';

export const Content = styled.section`
  margin: auto -24px -80px -24px;

  .centered {
    max-width: 95vw;
    margin: auto auto;
  }
  & h2 {
    margin-top: 32px;
    text-align: center;
    font-size: 60px;
  }

  & h3 {
    font-size: 36px;
    margin-bottom: 40px;
    text-align: center;
  }

  ${media.large} {
    & h2 {
      font-size: 56px;
    }
  }

  ${media.medium} {
    & h2 {
      font-size: 40px;
    }

    & h3 {
      font-size: 18px;
    }
  }

  ${media.medium} {
    & h2 {
      font-size: 32px;
    }

    & h3 {
      font-size: 16px;
    }
  }
`;

export const BenefitsSection = styled.section`
  width: 100%;
  max-width: 95vw;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 32px;
  font-family: Avenir;
  margin: 0 auto;
`;

export const CustomCard = styled.div`
  display: flex;
  justify-content: center;
  background-color: #ffffff;
  border-radius: 16px;
  box-shadow: 0 2px 4px 0 rgba(142, 142, 142, 0.5);
  padding: 48px;
  max-width: 90vw;
`;

export const MaxedContainer = styled.div`
  max-width: ${maxes.width};
  padding: 24px;
`;

export const RegistroBannerWrapper = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  padding: 0 12px 24px;
  font-family: Avenir, -apple-system, sans-serif;

  ${media.medium} {
    padding: 0 24px 40px;
  }

  @media (min-width: 993px) {
    padding: 0px;
    margin-top: 32px;
  }
`;

export const RegistroBanner = styled.section`
  position: relative;
  width: 100%;
  max-width: 520px;
  overflow: hidden;
  border-radius: 16px;

  .registro-mobile {
    display: block;
  }

  .registro-desktop {
    display: none;
  }

  .registro-content {
    display: flex;
    flex-direction: row;
    align-items: center;
  }

  .registro-left {
    flex: 1;
    display: flex;
    flex-direction: column;
    gap: 10px;
    padding: 10px 12px 20px 20px;
    min-width: 0;
  }

  .registro-title-row {
    display: flex;
    align-items: flex-start;
    gap: 2px;
  }

  .registro-pin {
    flex-shrink: 0;
    color: #00843d;
    font-size: 20px;
    margin-top: 2px;
  }

  .registro-title {
    margin: 0;
    font-size: 18px;
    text-align: left;
    font-weight: 800;
    line-height: 1.15;
    letter-spacing: -0.3px;
  }

  .registro-city {
    color: #00843d;
    font-size: 24px;
  }

  .registro-headline {
    display: block;
    color: #181818;
  }

  .registro-text p {
    margin: 0;
    font-size: 13px;
    line-height: 1.4;
    color: #181818;
  }

  .registro-cta-wrap {
    position: relative;
    margin-top: 6px;
    padding-right: 16px;
  }

  .registro-sparkles {
    position: absolute;
    top: -10px;
    right: 0;
    display: flex;
    gap: 3px;
    transform: rotate(25deg);
    pointer-events: none;
    z-index: 1;

    span {
      display: block;
      width: 2px;
      height: 11px;
      background: #00843d;
      border-radius: 1px;
    }
  }

  .registro-cta {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 10px;
    width: 100%;
    padding: 13px 10px 13px 22px;
    background: #fe8b13;
    border-radius: 16px;
    color: #ffffff;
    font-size: 14px;
    padding: 8px;
    font-weight: 700;
    text-decoration: none;
    transition: background 0.2s, opacity 0.2s;
  }

  .registro-cta-icon {
    flex-shrink: 0;
    width: 28px;
    height: 28px;
    display: flex;
    align-items: center;
    justify-content: center;
    background: #ffffff;
    border-radius: 50%;
    color: #00843d;

    svg {
      font-size: 18px;
    }
  }

  .registro-cta:hover {
    opacity: 0.95;
  }

  .registro-illustration {
    flex-shrink: 0;
    width: 46%;
    max-width: 240px;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 8px 0 8px 0;

    img {
      width: 77%;
      position: absolute;
      height: auto;
      object-fit: contain;
      display: block;
    }
  }

  .location-icon {
    font-size: 28px;
    color: #00843d;
    vertical-align: bottom;
  }

  ${media.medium} {
    border-radius: 20px;

    .registro-title {
      font-size: 28px;
      text-align: left;
    }

    .registro-pin {
      font-size: 28px;
      margin-top: 3px;
    }

    .registro-text p {
      font-size: 16px;
      max-width: 400px;
    }

    .registro-cta-wrap {
      padding-right: 24px;
    }

    .registro-cta {
      width: auto;
      max-width: 340px;
      width: 150px;
      padding: 6px 8px;
      font-size: 14px;
      position: relative;
      z-index: 1;
    }

    .registro-cta-icon {
      width: 24px;
      height: 24px;

      svg {
        font-size: 22px;
      }
    }

    .registro-illustration {
      width: 44%;
      max-width: 300px;
      padding: 16px 0 16px 0;
    }
  }

  ${media.small} {
    .registro-title {
      font-size: 18px;
      text-align: left;
    }

    .registro-pin {
      font-size: 18px;
      margin-top: 3px;
    }

    .registro-text p {
      font-size: 12px;
    }

    .registro-cta {
      font-size: 13px;
      width: max-content;
    }
  }

  @media (min-width: 993px) {
    max-width: 100%;
    background: linear-gradient(to right, #006b32, #00ae42);
    border: none;
    border-radius: 0;

    .registro-mobile {
      display: none;
    }

    .registro-desktop {
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding: 28px 80px;
      gap: 40px;
    }

    .registro-desktop-title {
      font-size: 30px;
      font-weight: 800;
      color: #ffffff;
      margin: 0 0 6px;
      line-height: 1.2;
    }

    .registro-desktop-subtitle {
      font-size: 15px;
      color: rgba(255, 255, 255, 0.85);
      margin: 0;
    }

    .registro-desktop-cta {
      flex-shrink: 0;
      background: #ffffff;
      color: #00843d;
      font-weight: 700;
      font-size: 16px;
      padding: 18px 36px;
      border-radius: 12px;
      text-decoration: none;
      white-space: nowrap;
      transition: opacity 0.2s;
    }

    .registro-desktop-cta:hover {
      opacity: 0.9;
    }
  }
`;
